import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-leave-sanction-form',
  templateUrl: './leave-sanction-form.component.html',
  styleUrls: ['./leave-sanction-form.component.css']
})
export class LeaveSanctionFormComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// ./src/app/hrms/Attendance-Leaves/leave-sanction/leave-sanction-form/leave-sanction-form.component.ts